// MARK://dhk8/admin-shell/lib/queries/contacts
// Queries tipadas de clientes/CRM — F2.5 / ADR-0009. El Admin lee contactos por el
// grafo (crm-contacts), tenant del JWT. Escrituras (create/update) + lealtad siguen REST.
import { graphql } from '../../gql/index.js'

export const AdminContactsQuery = graphql(`
  query AdminContacts($limit: Int, $q: String) {
    contacts(limit: $limit, q: $q) {
      items {
        id
        tenantId
        firstName
        lastName
        fullName
        source
        notes
        tags
        lastVisitAt
        totalOrdersCount
        totalSpentCents
        loyaltyPoints
        loyaltyVisits
        phones { id phone label isPrimary }
        emails { id email label isPrimary }
        addresses { id label street city state country zip isPrimary }
        fiscalEntities { id rfc legalName regimeCode zipCode usoCfdi invoiceEmail isDefault }
        createdAt
        updatedAt
      }
      total
      page
      limit
    }
  }
`)

export const AdminContactQuery = graphql(`
  query AdminContact($id: ID!) {
    contact(id: $id) {
      id
      tenantId
      firstName
      lastName
      fullName
      source
      notes
      tags
      lastVisitAt
      totalOrdersCount
      totalSpentCents
      loyaltyPoints
      loyaltyVisits
      phones { id phone label isPrimary }
      emails { id email label isPrimary }
      addresses { id label street city state country zip isPrimary }
      fiscalEntities { id rfc legalName regimeCode zipCode usoCfdi invoiceEmail isDefault }
      createdAt
      updatedAt
    }
  }
`)


// ── F9.12 / ADR-0008 / ADR-0009: escrituras de CRM por el grafo (mutations) ──
// crm-contacts = variante RLS B (findById no filtra por tenant → guard IDOR en el
// resolver). tenant del JWT, NUNCA arg. Sub-listas reemplazan la lista completa.
export const AdminCreateContactMutation = graphql(`
  mutation AdminCreateContact($input: CrmCreateContactInput!) {
    createContact(input: $input) {
      id
      tenantId
      firstName
      lastName
      fullName
      source
      notes
      tags
      lastVisitAt
      totalOrdersCount
      totalSpentCents
      loyaltyPoints
      loyaltyVisits
      phones { id phone label isPrimary }
      emails { id email label isPrimary }
      addresses { id label street city state country zip isPrimary }
      fiscalEntities { id rfc legalName regimeCode zipCode usoCfdi invoiceEmail isDefault }
      createdAt
      updatedAt
    }
  }
`)

export const AdminUpdateContactMutation = graphql(`
  mutation AdminUpdateContact($id: ID!, $input: CrmUpdateContactInput!) {
    updateContact(id: $id, input: $input) {
      id
      tenantId
      firstName
      lastName
      fullName
      source
      notes
      tags
      lastVisitAt
      totalOrdersCount
      totalSpentCents
      loyaltyPoints
      loyaltyVisits
      phones { id phone label isPrimary }
      emails { id email label isPrimary }
      addresses { id label street city state country zip isPrimary }
      fiscalEntities { id rfc legalName regimeCode zipCode usoCfdi invoiceEmail isDefault }
      createdAt
      updatedAt
    }
  }
`)

// Config de lealtad del tenant (upsert; tenant del JWT, NO arg).
// F6.2 R3b: lectura de la config de lealtad por el grafo (crm-contacts, tenant del
// JWT). Reemplaza el GET REST /api/loyalty/config. El write ya estaba en el grafo.
export const AdminLoyaltyConfigQuery = graphql(`
  query AdminLoyaltyConfig {
    loyaltyConfig {
      tenantId
      enabled
      pointsPerVisit
      tiers { id name threshold color }
    }
  }
`)

export const AdminSaveLoyaltyConfigMutation = graphql(`
  mutation AdminSaveLoyaltyConfig($input: CrmLoyaltyConfigInput!) {
    saveLoyaltyConfig(input: $input) {
      tenantId
      enabled
      pointsPerVisit
      tiers { id name threshold color }
    }
  }
`)
